<template>
  <div class="connection-container">
    <div v-if="appRefreshing">
      <div class="renew-connection pa-0">
        <v-icon class="vcs-logo-msuite-grey"></v-icon>
        <div class="progress-indicator"></div>
      </div>
    </div>
    <v-row v-else class="ma-0">
      <v-col cols="12" class="d-flex h-full pa-0">
        <issue-modal v-model="resolveIssueModal" :app="recentClickApp"></issue-modal>
        <div class="left-container py-4 h-full primary2-100">
          <div class="p-relative" style="height: 36px;">
            <div class="search-section">
              <div class="input-section" :class="{'focus': isFocusSearch}">
                <v-icon class="icon-magnify primary2-800"></v-icon>
                <input @focus="isFocusSearch = true" @blur="isFocusSearch = false" v-model="search" type="text"
                       ref="searchInput" :placeholder="$t('APPLICATIONS.SEARCH_APPS')">
                <v-icon v-if="search" class="icon-remove-grey cursor-pointer" @click="clearSearch()"></v-icon>
              </div>
              <v-tooltip open-delay="200" bottom>
                <template v-slot:activator="{on, attrs}">
                  <vcs-btn v-on="on" :ripple="false" v-bind="attrs" width="36" height="36" @click="refreshAppsHandler"
                           class="primary2-150 ml-2" icon>
                    <v-icon class="icon-reload primary2-950"></v-icon>
                  </vcs-btn>
                </template>
                <span>{{ $t('SDP_APP.RENEW_APP_LIST') }}</span>
              </v-tooltip>
            </div>
          </div>
          <div v-if="(!binding.sdpConnected && binding.sdpConnectError) || listAppState !== 'show'" class="w-full d-flex flex-column align-center justify-start"
               style="height: calc(100vh - 120px); padding-top: 150px">
            <div v-if="!binding.sdpConnected && binding.sdpConnectError" class="mx-4" style="transform: translateY(-135px);">
              <error-card  class="mb-3 mt-1">
                <template v-slot:default>
                  <div>{{$t('APP.ERROR_INTERNET_COMMON.1')}}</div>
                  <div>{{$t('APP.ERROR_INTERNET_COMMON.2')}}</div>
                </template>
              </error-card>
            </div>
            <template v-else-if="listAppState === 'loading'">
              <vcs-loading class="mt-14" size="56"></vcs-loading>
              <div>{{ $t('APP.LOADING') }}</div>
            </template>
            <template v-else-if="listAppState === 'disconnected'">
              <div>{{$t('APP.APP_DISCONNECTED.1')}}</div>
              <div>{{$t('APP.APP_DISCONNECTED.2')}}</div>
            </template>
          </div>
          <template v-else>
            <div class="left-side w-full overflow-auto px-3 pb-6">
              <template v-if="sdpApps && sdpApps[0].length">
                <div class="d-flex align-center my-2 font-14 font-weight-semi-bold text-primary2-700">
                  <v-icon class="vcs-icon-global yc-icon--small primary2-700"></v-icon>
                  <span class="mx-1">{{$t('APP.DIRECT_ACCESS_APP')}}</span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on"
                              class="vcs-icon-question-circle-outline yc-icon--small primary2-500 cursor-pointer"></v-icon>
                    </template>
                    <span>{{$t('APP.DIRECT_ACCESS_APP_TOOLTIP')}}</span>
                  </v-tooltip>
                </div>
                <template v-for="sdpApp in sdpApps[0]">
                  <template
                      v-if="
                      sdpApp &&
                      sdpApp.authorized_app &&
                      !sdpApp.authorized_app.app.parent"
                  >
                    <sdp-app
                        :key="sdpApp.authorized_app.app.app_id"
                        :app="sdpApp"
                        :selected="selectedApp && sdpApp.authorized_app.app.app_id===selectedApp.authorized_app.app.app_id"
                        :authenInfo="binding['authenAuthenInfo']"
                        :sdpConnected="binding.sdpConnected"
                        :deviceVerifyResult="binding.deviceVerifyResult"
                        @trustPointLevelUpShow="sdpTrustPointDialogContainer.value = true"
                        @openDetail="selectApp"
                        @requestApprove="openRequestApproveApp"
                        @resolveIssueBaseline="introduceResolveIssue"
                    >
                    </sdp-app>
                  </template>
                </template>
              </template>
              <template v-if="sdpApps && sdpApps[1].length">
                <div class="d-flex align-center my-2 font-14 font-weight-semi-bold text-primary2-700">
                  <v-icon class="vcs-icon-application2 yc-icon--small primary2-700"></v-icon>
                  <span class="mx-1">{{$t('APP.INTERMEDIATE_ACCESS_APP')}}</span>
                  <v-tooltip bottom style="width: 324px;">
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on"
                              class="vcs-icon-question-circle-outline yc-icon--small primary2-500 cursor-pointer"></v-icon>
                    </template>
                    <div style="width: 324px;" v-html="$t('APP.INTERMEDIATE_ACCESS_APP_TOOLTIP')"></div>
                  </v-tooltip>
                </div>
                <template v-for="sdpApp in sdpApps[1]">
                  <template
                      v-if="
                      sdpApp &&
                      sdpApp.authorized_app &&
                      !sdpApp.authorized_app.app.parent"
                  >
                    <sdp-app
                        :key="sdpApp.authorized_app.app.app_id"
                        :app="sdpApp"
                        :selected="selectedApp && sdpApp.authorized_app.app.app_id===selectedApp.authorized_app.app.app_id"
                        :authenInfo="binding['authenAuthenInfo']"
                        :sdpConnected="binding.sdpConnected"
                        :deviceVerifyResult="binding.deviceVerifyResult"
                        @trustPointLevelUpShow="sdpTrustPointDialogContainer.value = true"
                        @openDetail="selectApp"
                        @requestApprove="openRequestApproveApp"
                        @resolveIssueBaseline="introduceResolveIssue"
                    >
                    </sdp-app>
                  </template>
                </template>
              </template>
              <div v-if="!sdpApps" class="text-center font-weight-semi-bold text-primary2-400">
                {{ isAppListAvailable ? $t('APPLICATIONS.LOADING') : $t('APPLICATIONS.APP_BLANK')}}
              </div>
              <template v-if="sdpApps && !sdpApps[0].length && !sdpApps[1].length">
                <div v-if="!search" class="text-center font-weight-semi-bold text-primary2-400">
                  {{ $t('APPLICATIONS.APP_BLANK') }}
                </div>
                <div v-else class="text-center text-primary2-600">
                  <div class="font-weight-semi-bold ">
                    {{ $t('APPLICATIONS.NO_SEARCH_RESULT') }}
                  </div>
                  <div class="font-12 mt-1">
                    {{ $t('APPLICATIONS.TRY_WITH_OTHER_KEYWORD') }}
                  </div>
                </div>
              </template>
            </div>

          </template>

        </div>
        <div class="right-container p-relative">
          <!--Block internet policy-->
          <div v-if="hasBlockInternetApp" @click="openBlockInternetPolicyModal = true"
               class="block-internet-policy-container">
            <v-icon class="icon-block-network-16"></v-icon>
            <span>{{ $t('SDP_APP.BLOCK_NETWORK') }}</span>
          </div>
          <block-internet-policy v-model="openBlockInternetPolicyModal"
                                 :lang="binding && binding['setting'] ? binding['setting']['language'] : null"
                                 @close="openBlockInternetPolicyModal = false"></block-internet-policy>

          <switch-server-modal v-if="openSwitchServerModal" v-model="openSwitchServerModal"
                               :currentServerName="binding.backendServerNameCurrentValue"
                               @close="openSwitchServerModal = false"></switch-server-modal>
          <div class="background-circle-v2" @click="closeDetail">
            <div :class="{'enabled': switcherState}">
              <div class="circle circle-1 stroke-2" style=" "></div>
              <div class="circle circle-2 stroke-2" style=""></div>
              <div class="circle circle-3 stroke-2" style=""></div>
              <div class="circle circle-4 stroke-2" style=""></div>
              <div class="circle circle-5 stroke-2" style=""></div>
            </div>
            <v-icon class="vcs-logo-msuite-white"></v-icon>
          </div>
          <div class="detail-information-container">
            <div class="d-flex flex-column">
              <div class="detail-item">
                <span class="detail-title">{{ $t('ACCOUNT.ACCOUNT_INFO') }}</span>
                <span class="detail-value">
                  <v-tooltip top open-delay="200">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">{{accountEmail}}</span>
                    </template>
                    <span>{{accountEmail}}</span>
                  </v-tooltip>
                </span>
              </div>
              <div
                  @click="openSwitchServerModal = true" class="detail-item mt-4 change-server detail-item-clickable">
                <span class="detail-title">{{ $t('OPTIONS.SERVER') }}</span>
                <div class="d-flex">
                  <span class="detail-value">{{
                      binding.backendServerNameCurrentValue || "N/A"
                    }}</span>
                  <v-icon class="vcs-icon-chevron-right-square yc-icon--small primary2-white ml-2"></v-icon>
                </div>
              </div>
              <div v-if="numberOfBaselineIssues" @click="onClickOpenIssueModal" class="detail-item mt-4" :class="{'detail-item-clickable': numberOfBaselineIssues}">
                <span class="detail-title">{{ $t('SCAN_DEVICE.DEVICE_POLICY') }}</span>
                <span
                    class="detail-value">
                  <span v-if="numberOfBaselineIssues > 0" class="text-red-500">{{$t('SCAN_DEVICE.DETECTED_ISSUES', {issues: numberOfBaselineIssues})}}</span>
                  <template v-else>
                    {{ $t('SCAN_DEVICE.NO_ISSUES') }}
                  </template>
                </span>
              </div>
            </div>
          </div>
          <v-navigation-drawer
              v-model="drawer"
              stateless
              hide-overlay
              width="296"
              height="60%"
              absolute
              class="detail-container"
          >
            <v-card class="p-relative" v-if="selectedApp">
              <v-btn @click="closeDetail" class="btn-close-panel" icon>
                <v-icon class="icon-remove-grey"></v-icon>
              </v-btn>
              <v-card-title class="d-flex px-4 py-3">
                <div style="max-width: 90%">
                  <v-tooltip open-delay="200" top>
                    <template v-slot:activator="{ on }">
                      <div v-on="on" class="text-truncate font-16 line-height-1 font-weight-semi-bold">
                        {{ selectedApp.authorized_app.app.name }}
                      </div>
                    </template>
                    <div class="font-weight-semi-bold">
                      {{ selectedApp.authorized_app.app.name }}
                    </div>
                  </v-tooltip>
                </div>
              </v-card-title>
              <div class="mx-4">
                <v-divider></v-divider>
              </div>
              <div class="d-flex flex-column detail-content">
                <v-card-text class="pb-2 mb-6" style="overflow: auto">
                  <error-card v-if="hasBaselineIssue || declineApproveApp || alertError"
                              :is-system-error="false"
                              :error="declineApproveApp ? $t('SDP_APP.REJECT_APP') : (hasBaselineIssue ? $t('SDP_APP.HAS_BASELINE_ISSUE') : alertError)"
                              class="my-0 font-12"
                              icon-classes="vcs-icon-alert-triangle-16 mr-1"
                  ></error-card>
                  <div
                      v-else-if="needApproveApp"
                      :class="pendingApproveApp ? 'cyan-100 text-cyan-700' : 'text-yellow-700 yellow-100'"
                      class="d-flex font-12 font-weight-medium mb-2 pa-2 justify-center rounded-lg"
                  >
                    <div>
                      <v-icon v-if="pendingApproveApp" class="icon-leading mr-2 cyan-700"></v-icon>
                      <v-icon v-else class="icon-alert-circle mr-2 yellow-600"></v-icon>
                    </div>
                    <div>
                      <template v-if="pendingApproveApp">
                        {{ $t('SDP_APP.PENDING_APPROVED_MESSAGE') }}
                      </template>
                      <template v-else>
                        {{ $t('SDP_APP.NEED_APPROVED_MESSAGE') }}
                      </template>
                    </div>
                  </div>
                  <v-row>
                    <template v-for="field in detailsValue">
                      <v-col class="font-12 py-1 pr-2 text-primary2-600 font-weight-medium text-right"
                             :key="field.label" cols="5">{{ field.label }}
                      </v-col>
                      <v-col :key="field.label+'val'" class="font-12 py-1 pl-2" :class="field.class" cols="7">
                        <template v-if="field.type==='text'">
                          {{ field.value }}
                        </template>
                        <template v-else-if="field.type === 'list'">
                          <ul>
                            <li v-for="val in field.value" :key="val.name">
                              {{ val.name }}
                            </li>
                          </ul>
                        </template>
                        <template v-else-if="field.type === 'time'">
                          <countdown
                              v-if="selectedApp.started"
                              style="margin-top: 2px"
                              :time="field.value.expired_time"
                              :timeZone="field.value.time_zone"
                              :timeZoneOffset="field.value.time_zone_offset"
                              :class="expiredDuration ? 'text-red-600' : ''"
                              @expiredDuration="expiredTime"
                          ></countdown>
                          <div v-else>--:--:--</div>
                        </template>
                      </v-col>
                    </template>

                  </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-center primary2-white pb-4 w-full"
                                style="bottom: 0; position: fixed">
                  <vcs-btn
                      v-if="!selectedApp.starting && !selectedApp.restarting && !alertError || hasBaselineIssue"
                      height="32px"
                      class="action-btn"
                      @click="appActionHandler(selectedApp)"
                      :disabled="declineApproveApp || pendingApproveApp || opening"
                      :class="!selectedApp.started && !needApproveApp && !hasBaselineIssue ? 'cyan-200' : 'primary2-100'"
                  >
                    <v-icon
                        :class="{
                         'icon-power': selectedApp.started,
                         'icon-key-lock': needApproveApp,
                      }"
                        class="mr-1"
                    ></v-icon>
                    <template v-if="selectedApp.started">
                      <span>{{ $t('SDP_APP.CLOSE_APP_CONNECTION') }}</span>
                    </template>
                    <template v-else-if="needApproveApp">
                      <span>
                        {{ $t('SDP_APP.REQUEST_CONNECT') }}
                      </span>
                    </template>
                    <template v-else-if="hasBaselineIssue">
                      {{ $t('SDP_APP.RESOLVE') }}
                    </template>
                    <template v-else><span class="text-cyan-700">{{ $t('SDP_APP.OPEN_APP_CONNECTION') }}</span>
                    </template>
                  </vcs-btn>
                </v-card-actions>
              </div>
            </v-card>
          </v-navigation-drawer>
          <x-switcher-custom :switcherState="switcherState" :disabled="binding['sdpStartStopAll']" @closeAll="stopAllApp"
                             @startAll="startAllApp"></x-switcher-custom>

          <div class="card-version" v-if="this.updateStatus && this.updateStatus.version"
               style="bottom: 70px;position:absolute;width: 100%;display: flex;font-weight: 600;font-size: 12px;justify-content: center;color: #94949E;">
            <span class="sub-text">{{ $t('OPTIONS.VERSION') }} {{ updateStatus['version'] }}</span>
          </div>
        </div>
      </v-col>
    </v-row>
    <vcs-modal
        v-model="requestConnectModal.dialog"
        :options="requestConnectModal"
        @ok="requestConnect"
        persistent
        max-width="400px"
    >
      <div class="text-primary2-800 text-break">
        <span>{{ $t("SDP_APP.SEND_REQUEST_CONNECT_APP") }}:</span> <span class="font-weight-bold" v-if="approveApp">
          {{ approveApp.authorized_app.app.name || '' }}
        </span>
      </div>
      <div class="custom-field mt-4">
        <v-textarea
            required
            :label="$t('SDP_APP.MESSAGE_REQUEST_CONNECT')"
            v-model="requestConnectModal.params.message"
            rows="3"
            autofocus
            color="indigo"
            :no-resize="true"
            height="120"
            filled
            class="custom-textarea"
        ></v-textarea>
      </div>
    </vcs-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import errorService from "@/services/errorService";
import msDataProvider from "@/services/msDataProvider";
import SdpApp from "./partials/connection/SdpApp.vue";
import uiService from "@/services/uiService";
import {addAction} from "@/services/firebase/writeData";
import Countdown from "@/views/main/partials/connection/Countdown.vue";
import ErrorCard from "@/components/partials/ErrorCard.vue";
import IssueModal from "@/views/main/partials/connection/IssueModal.vue";
import SwitchServerModal from "@/views/main/partials/connection/SwitchServerModal.vue";
import AutoStartAppService from "@/services/autoStartAppService";
import ratingService from "../../services/ratingService";
import XSwitcherCustom from "@/components/XSwitcherCustom.vue";
import Policy from "@/constant/policy"
import BlockInternetPolicy from "@/views/main/partials/connection/BlockInternetPolicy.vue";

export default Vue.extend({
  props: [],
  name: "Index",
  components: {
    IssueModal,
    ErrorCard,
    SdpApp,
    Countdown,
    XSwitcherCustom,
    SwitchServerModal,
    BlockInternetPolicy
  },
  data() {
    return {
      errorService,
      binding: {
        sdpConnected: null,
        sdpConnectError: null
      },
      search: "",
      drawer: false,
      selectedApp: null,
      recentClickApp: null,
      appRefreshing: false,
      appDisconnecting: false,
      opening: false,
      requestConnectModal: {
        title: this.$t("SDP_APP.CONNECT_REQUEST"),
        ok: this.$t("SDP_APP.SEND_REQUEST"),
        rules: {
          message: [(v) => !!v || this.$t("SDP_APP.MESSAGE_TO_ADMINISTRATOR")],
        },
        onlySubmitBtn: true,
        dialog: false,
        params: {},
        loading: false,
        valid: false,
        app: {}
      },
      approveApp: null,
      alertShown: false,
      resolveIssueModal: false,
      autoStartAllApp: false,
      timeout: null,
      interval: null,
      isFocusSearch: false,
      loading: true,
      updateStatus: null,
      policies: Policy,
      openSwitchServerModal: false,
      openBlockInternetPolicyModal: false,
      expiredDuration: false,
      // isShowNotiConnection: false,
      isShowNotiConnectionTimeout: 0,
      sdpConnectedChecker: 0,
      listAppState: "loading", // show, disconnected
      isAppListAvailable: true //used in cases where the account does not have access rights to the app or is violating a baseline policy that prevents retrieving the app list
    };
  },
  watch: {
    'binding.sdpApps': {
      handler(val) {
        if (val) {
          this.selectedApp = val.find(app => this.selectedApp?.authorized_app?.app?.app_id === app?.authorized_app?.app?.app_id);
        }
      }
    },
    search: {
      handler() {
        this.closeAppDetail()
      }
    },
    autoStartAllApp(val) {
      AutoStartAppService.update(this.binding.authenAuthenInfo?.user_info?.user_id, val);
    }
  },
  computed: {
    hostPortHtml() {
      if (
          !this.selectedApp ||
          !this.selectedApp.authorized_app ||
          !this.selectedApp.authorized_app.app.destination_setting
      ) {
        return;
      }
      if (
          this.selectedApp.app_proxy_info &&
          this.selectedApp.app_proxy_info.destination_display_text
      ) {
        return this.selectedApp.app_proxy_info.destination_display_text;
      }

      const destinationSetting =
          this.selectedApp.authorized_app.app.destination_setting;
      if (destinationSetting.range_mode) {
        return `${destinationSetting.start_ip}  &rarr;  ${destinationSetting.end_ip}:${destinationSetting.start_port} &rarr; ${destinationSetting.end_port}`;
      } else if (destinationSetting.dynamic_mode) {
        return `${destinationSetting.ip_def}:${destinationSetting.port_def}`;
      } else {
        let host = destinationSetting.ip;
        let port = destinationSetting.port;
        if (destinationSetting.forward_setting) {
          if (destinationSetting.forward_setting.host) {
            host = destinationSetting.forward_setting.host;
          }
          if (destinationSetting.forward_setting.port) {
            port = destinationSetting.forward_setting.port;
          }
        }
        return `${host}:${port}`;
      }
    },
    sdpApps() {
      let clickableApps = [];
      let unclickableApps = [];
      if (!this.binding.sdpApps) {
        return null;
      }
      this.binding.sdpApps.forEach(app => {
        if (app.authorized_app && !app.authorized_app.app.parent) {
          if (this.clickable(app)) {
            clickableApps.push(app);
          } else {
            unclickableApps.push(app);
          }
        }
      });
      if (this.search) {
        clickableApps = this.filter(clickableApps, this.search.trim());
        unclickableApps = this.filter(unclickableApps, this.search.trim());
      }
      clickableApps.sort((item1, item2) => {
        return item1.authorized_app?.app?.name?.localeCompare?.(
            item2.authorized_app?.app?.name
        );
      });
      unclickableApps.sort((item1, item2) => {
        return item1.authorized_app?.app?.name?.localeCompare?.(
            item2.authorized_app?.app?.name
        );
      });
      return [clickableApps, unclickableApps];
    },
    hasBaselineIssue() {
      return this.selectedApp?.authorized_app?.error_info?.error_code === 417
    },
    needApproveApp() {
      return this.selectedApp?.authorized_app?.error_info?.error_code === 401
          && this.selectedApp?.authorized_app?.error_info?.message === 'Approve Needed';
    },
    pendingApproveApp() {
      return this.needApproveApp && this.selectedApp?.authorized_app?.access_request?.status === 'Pending'
    },
    declineApproveApp() {
      return this.needApproveApp && this.selectedApp?.authorized_app?.access_request?.status === 'Declined'
    },
    detailsValue() {
      const selectedApp = this.selectedApp;
      return [
        {
          label: this.$t('SDP_APP.APP_NAME'),
          key: 'authorized_app.app.name',
          type: 'text',
          value: selectedApp.authorized_app.app.name
        },
        {
          label: this.$t('SDP_APP.APP_STATUS'),
          value: selectedApp.started ? this.$t('SDP_APP.OPEN_STATUS') : this.$t('SDP_APP.CLOSE_STATUS'),
          type: 'text',
          class: selectedApp.started ? 'text-green-600' : ''
        },
        {
          label: this.$t('SDP_APP.EXPIRED_TIME'),
          value: {
            expired_time: selectedApp.authorized_app.expired_time,
            time_zone: selectedApp.authorized_app.time_zone,
            time_zone_offset: selectedApp.authorized_app.time_zone_offset,
            current_time: selectedApp.authorized_app.current_time,
            appID: selectedApp.authorized_app.app.app_id
          },
          type: 'time',
          class: selectedApp.started ? 'text-green-600' : 'text-primary2-950',
        },
        {
          label: this.$t('SDP_APP.DOMAIN'),
          value: this.hostPortHtml,
          type: 'text'
        },
        {
          label: this.$t('SDP_APP.POLICIES'),
          value: selectedApp.app_proxy_info?.applied_access_policies || [],
          type: 'list'
        },
        {
          label: this.$t('SDP_APP.CONNECT_PERMISSION'),
          value: this.needApproveApp ? this.$t('SDP_APP.DECLINE') : this.$t('SDP_APP.ACCEPT'),
          class: this.needApproveApp ? 'text-red-600' : 'text-green-600',
          type: 'text'
        },
      ]
    },
    haveIssueBaseline() {
      if (this.binding.sdpApps) {
        for (const sdpApp of this.binding.sdpApps) {
          if (
              sdpApp.authorized_app &&
              sdpApp.authorized_app.error_info &&
              sdpApp.authorized_app.error_info.error_code &&
              sdpApp.authorized_app.error_info.error_code === 417
          ) {
            return true;
          }
        }
      }
      return false;
    },
    alertError() {
      if (this.needApproveApp) {
        return '';
      }
      return this.selectedApp?.authorized_app?.error_info?.message ||
          (this.selectedApp?.error ? this.$t("ERROR_SERVICE.ERROR_GATEWAY") : false);
    },
    switcherState() {
      if (!this.binding.sdpConnected) {
        return false;
      } else {
        return true;
      }
    },
    listPolicy() {
      const result = [];
      if (this.binding.summaryPolicies && this.binding.summaryPolicies.data) {
        const summaryPoliciesData = this.binding.summaryPolicies.data;
        Object.keys(summaryPoliciesData).map(policy => {
          if (summaryPoliciesData[policy].value && summaryPoliciesData[policy].value.length > 0) {
            result.push(this.policies[policy]);
          }
        });
      }
      return result;
    },
    numberOfBaselineIssues() {
      if (this.binding.deviceVerifyResult && this.binding.deviceVerifyResult.baseline_verify_results) {
        const data = this.binding.deviceVerifyResult.baseline_verify_results;
        if (Array.isArray(data)) {
          let result = 0;
          data.forEach(baselines => {
            if (Array.isArray(baselines.rule_verify_results)) {
              const ruleVerifyResults = baselines.rule_verify_results.filter(i => !i.result);
              result += ruleVerifyResults.length;
            }
          });
          return result;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    hasBlockInternetApp() {
      return this.sdpApps && (this.sdpApps[0].some(app => !!app.app_proxy_info?.applied_access_policies?.find(p => p?.network_setting?.block_all)) ||
          this.sdpApps[1].some(app => !!app.app_proxy_info?.applied_access_policies?.find(p => p?.network_setting?.block_all)))
    },
    accountEmail() {
      return this.binding?.authenAuthenInfo?.user_info?.email || "N/A"
    }
  },
  methods: {
    closeDetail() {
      this.drawer = false;
      this.selectedApp = null;
    },
    startAllAppAfterLoginWorker() {
      this.interval = setInterval(() => {
        const userId = this.binding.authenAuthenInfo?.user_info?.user_id;
        if (userId && AutoStartAppService.isStartApp(userId) && this.binding.sdpApps.length) {
          AutoStartAppService.startApp(userId);
          this.startAllApp();
          clearInterval(this.interval);
        }
      }, 500);
      this.timeout = setTimeout(() => {
        clearInterval(this.interval);
        clearTimeout(this.timeout);
      }, 15000)
    },
    appActionHandler(app) {
      if (app?.authorized_app?.error_info?.error_code === 401) {
        this.requestConnectModal.app = app;
        this.approveApp = app;
        this.requestConnectModal.dialog = true;
        return;
      }
      if (this.hasBaselineIssue) {
        this.introduceResolveIssue({app: this.selectedApp});
        return;
      }
      if (app?.started) {
        this.stop();
      } else {
        this.start();
      }
    },
    introduceResolveIssue({app}) {
      this.recentClickApp = app;
      this.resolveIssueModal = true;
    },
    start(app = this.selectedApp) {
      uiService.executeCommand("try", {
        async func() {
          await msDataProvider.executeCommand("sdpStartApp", {
            app_id: app.authorized_app.app.app_id,
          });
          setTimeout(() => {
            this.open(this.selectedApp);
          }, 100)
        },
        self: this,
      });
    },
    clickable(app) {
      return (
          app &&
          app.authorized_app &&
          app.authorized_app.app &&
          app.authorized_app.app.meta &&
          !!app.authorized_app.app.meta.direct_connect_app
      );
    },
    open(app) {
      if (!app.started || !this.clickable(app)) {
        return;
      }
      this.opening = true;
      setTimeout(async () => {
        await new Promise((f) => setTimeout(f, 500));
        await uiService.executeCommand(
            "try",
            {
              async func() {
                const data = await msDataProvider.executeCommand(
                    "sdpOpenApp",
                    app.authorized_app.app.app_id
                );
                if (
                    data.error_info &&
                    data.error_info.error_code &&
                    data.error_info.message
                ) {
                  await uiService.executeCommand("alertShow", {
                    message: data.error_info.message,
                  });
                }
              },
              self: this,
            },
            true
        );
        this.opening = false;
      }, 500);
    },
    async stop(app = this.selectedApp) {
      this.stopping = true;
      await msDataProvider.executeCommand(
          "sdpStopApp",
          app.authorized_app.app.app_id
      );
      this.stopping = false;
    },
    openRequestApproveApp({app}) {
      this.approveApp = app;
      this.requestConnectModal.dialog = true;
    },
    selectApp({app}) {
      if (this.selectedApp === app && this.drawer) {
        this.selectedApp = null;
        this.drawer = false;
        return;
      }
      this.selectedApp = app;
      this.drawer = true;
    },
    filter(sdpApps, search) {
      const apps = [];
      for (const sdpApp of sdpApps) {
        if (!this.match(sdpApp, search.trim())) {
          continue;
        }
        apps.push(sdpApp);
      }
      return apps;
    },
    matchString(value, search) {
      return ("" + value).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    match(sdpApp, search) {
      return (
          this.matchString(sdpApp.authorized_app.app.name, search) ||
          this.matchString(sdpApp.authorized_app.app.description, search) ||
          (sdpApp.authorized_app.access_rule &&
              (this.matchString(sdpApp.authorized_app.access_rule.name, search) ||
                  this.matchString(
                      sdpApp.authorized_app.access_rule.description,
                      search
                  ))) ||
          (sdpApp.app_proxy_info &&
              (this.matchString(sdpApp.app_proxy_info.protocol, search) ||
                  this.matchString(sdpApp.app_proxy_info.origin_host, search) ||
                  this.matchString(sdpApp.app_proxy_info.origin_port, search) ||
                  this.matchString(sdpApp.app_proxy_info.origin_start_ip, search) ||
                  this.matchString(sdpApp.app_proxy_info.origin_end_ip, search) ||
                  this.matchString(sdpApp.app_proxy_info.origin_start_port, search) ||
                  this.matchString(sdpApp.app_proxy_info.origin_end_port, search)))
      );
    },
    async refreshAppsHandler() {
      this.search = "";
      const bottomNavigation = document.querySelector(".custom-bottom-navigation");
      this.appRefreshing = true;
      bottomNavigation.style.display = "none";
      await uiService.executeCommand(
          "try",
          {
            async func() {
              await msDataProvider.executeCommand("sdpRefreshApps");
            },
          },
          true
      );
      setTimeout(async () => {
        this.appRefreshing = false;
        bottomNavigation.style.display = "flex";
        await addAction('click_to_refresh_app')
      }, 1000);
    },
    async requestConnect(callback) {
      this.requestConnectModal.loading = true;
      await uiService.executeCommand(
          "try",
          {
            async func() {
              const params = {message: this.requestConnectModal.params.message};
              params.app_id = this.approveApp?.authorized_app?.app?.app_id;
              await msDataProvider.executeCommand("sdpStartApp", params);
              if (typeof callback === 'function') {
                callback();
              }
            },
            self: this,
          },
          true
      );
      this.requestConnectModal.loading = false;
      this.requestConnectModal.dialog = false;
    },
    stopAllApp() {
      this.closeAppDetail()
      uiService.executeCommand("try", {
        async func() {
          await msDataProvider.executeCommand("sdpStopAppAll", {});
        },
        self: this,
      });
    },
    startAllApp() {
      this.listAppState = "loading";
      uiService.executeCommand("try", {
        async func() {
          await msDataProvider.executeCommand("sdpStartAppAll", {});
        },
        self: this,
      });
    },
    clearSearch() {
      this.search = "";
      this.$refs.searchInput.focus();
    },
    onClickOpenIssueModal() {
      if (this.numberOfBaselineIssues) {
        this.resolveIssueModal = true;
      }
    },
    async expiredTime(val) {
      this.expiredDuration = val;
    },
    closeAppDetail() {
      if (this.drawer) {
        this.selectedApp = null;
        this.drawer = false;
      }
    }
  },
  async created() {
    this.loading = true;
    uiService.registerCommand("requestConnect", (app) => {
      this.approveApp = app;
      this.requestConnectModal.dialog = true;
    });
    await msDataProvider.bindDataMany(
        [
          "sdpApps",
          "sdpConnected",
          "sdpConnectError",
          "setting",
          "authenAuthenInfo",
          "backendServerNameCurrentValue",
          "deviceVerifyResult",
          "summaryPolicies",
          "sdpStartStopAll",
          "sdpConnecting"
        ],
        this.binding,
        this,
        async (key, data) => {
          if (key === 'authenAuthenInfo' && data) {
            this.autoStartAllApp = AutoStartAppService.getData(this.binding.authenAuthenInfo?.user_info?.user_id)?.value || false;
            if (!this.interval) {
              this.startAllAppAfterLoginWorker();
            }
            if (data.user_info?.user_id) {
              this.updateStatus = await msDataProvider.executeCommand("updateGetStatus");
              ratingService.initRatings(this.updateStatus.version, data.user_info?.user_id);
            }
          }
          if (key === 'sdpApps') {
            this.isAppListAvailable = data !== null; //If sdpApps = null, it means the app list cannot be retrieved.
            if (data) {
              if (data.length > 0) {
                this.loading = false;
                // clearTimeout(this.isShowNotiConnectionTimeout);
                // this.isShowNotiConnection = false;
              }
              // const allAppStarted = data.filter(app => !app.authorized_app.app.parent).every(app => app.started || Object.keys(app.authorized_app.error_info).length > 0);
              const allAppStopped = data.filter(app => !app.authorized_app.app.parent).every(app => app.force_stopped || (!app.started && !app.starting && !app.restarting) && !app.authorized_app.error_info);
              if(this.binding["sdpConnected"] === true && allAppStopped) {
               this.stopAllApp();
              }
            }
          }

          if (key === 'sdpConnectError' && data) {
            this.closeAppDetail();
            // this.isShowNotiConnection = true;
            this.loading = false;
          }

          if (key === 'sdpConnected') {
            if (!data) {
              this.listAppState = "disconnected"
              // clearTimeout(this.isShowNotiConnectionTimeout);
              // this.isShowNotiConnectionTimeout = setTimeout(() => {
              //   this.isShowNotiConnection = true;
              // }, 20000)
            } else {
              this.loading = false;
              this.listAppState = "show";
              // clearTimeout(this.isShowNotiConnectionTimeout);
              // this.isShowNotiConnectionTimeout = 0;
              // this.isShowNotiConnection = false;
            }
          }
        },
        this
    );
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    clearInterval(this.sdpConnectedChecker);
    clearTimeout(this.timeout);
    clearInterval(this.interval);
    next();
  },
})
</script>

<style lang="scss">
.connection-container {
  .full-height {
    height: calc(100vh - 56px);
  }

  .left-container {
    width: 55%;
    z-index: 6;
    box-shadow: 4px 0 24px -4px #0000003D;

    .left-side {
      margin-top: 12px;
      height: calc(100vh - 120px);
    }

    .search-section {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      width: 100%;
      padding: 0 16px;

      .input-section {
        background: #D7D7DB;
        border-radius: 6px;
        display: flex;
        align-items: center;
        align-self: stretch;
        padding: 0 4px;
        gap: 2px;
        width: 100%;

        input {
          flex: 1;
          align-self: stretch;
          &:focus-within {
            outline: none;
          }
        }

        &.focus {
          box-shadow: 0 3px 7px 0 #0000001F;
          background: white;
          border: 1px solid #46A6FF;
        }
      }
    }
  }

  .right-container {
    height: 100vh;
    width: 45%;
    background: radial-gradient(100% 100% at 50% 50%, #1d1d1d 100%, #000000 100%);

    .error-card-container {
      position: absolute;
      top: 24px;
      z-index: 1000;
      width: 100%;
      display: flex;
      justify-content: center;
      max-height: 200px;

      .error-card {
        width: 90%;
        height: 100%;
      }
    }


    .detail-container {
      box-shadow: none;
      top: 24px !important;
      border-radius: 0 12px 12px 0;
      z-index: 4;

      .v-card {
        height: 100%;
      }

      .detail-content {
        height: 78%;
        overflow: auto;
      }

      .btn-close-panel {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 24px;
        height: 24px;
        border-radius: 4px;
      }

      .action-btn {
        border-radius: 64px;
        background: rgba(0, 0, 0, 0.1);
        .v-btn__content {
          line-height: 20px;
        }
      }
    }


    .detail-information-container {
      position: absolute;
      left: 16px;
      top: 24px;

      .detail-item {
        display: flex;
        flex-direction: column;
        padding: 6px 8px;
        max-width: 200px;

        .detail-title {
          font-size: 11px;
          color: #AFAFB7;
          margin-bottom: 4px;
        }

        .detail-value {
          font-size: 12px;
          line-height: 16px;
          color: #fff;
          font-weight: 500;
          word-break: break-word;
        }

        &.change-server {
          .vcs-icon-data-transfer-circle {
            width: 17px;
            height: 16px;
            -webkit-mask-size: 16px;
          }
        }

        &.detail-item-clickable {
          cursor: pointer;
          border-radius: 6px;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
          }

          &:active {
            background: rgba(0, 0, 0, 0.3);
          }
        }
      }
    }

    .block-internet-policy-container {
      position: absolute;
      bottom: 208px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      height: 28px;
      cursor: pointer;
      z-index: 2;

      span {
        color: #FF7883;
        font-weight: 500;
        font-size: 11px;
        margin-left: 12px;
      }

      &:before {
        content: "";
        width: 28px;
        height: 28px;
        border: 1px solid #FF7883;
        border-radius: 100px;
        display: inline-block;
        position: absolute;
        left: 0;
        transform: translateX(-6px);
        transition: width .1s ease;
      }

      &:hover {
        &:before {
          width: calc(100% + 12px);
        }
      }

      &:active {
        &:before {
          border-color: #C64A51;
        }

        span {
          color: #C64A51;
        }
      }
    }
  }

  .disconnect-content {
    background: radial-gradient(50% 50% at 50% 50%, #F8F8F8 0%, #D1D1D1 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .reconnect-btn {
      position: absolute;
      bottom: 80px;
      margin: 0 auto;
      color: white;
    }
  }
}
</style>
